import { ContactAliasesTable } from "contact/detail/ContactAliasesTable";
import React from "react";

interface Props {
  aliases: server.dto.ContactAlias[]
  canModify: boolean
  onDeleted: () => Promise<unknown>
}

export const ContactAliasesSection = (props: Props) => {
  const { aliases } = props;

  if (aliases.length === 0) {
    return null;
  }

  return <div className="flex-column gap">
    <div className="nav-text-regular">Aliases</div>
    <ContactAliasesTable
      aliases={aliases}
      canModify={props.canModify}
      onDeleted={props.onDeleted}
    />
  </div>
}
